<template>
  <div class="welcome f18">
    {{message}}
  </div>
</template>
<script>
export default {
  data() {
    return {
      message: '欢迎来到海渡职校！'
    }
  }
}

</script>
<style lang="scss" scoped>
.welcome {
  background: url(../assets/images/recommend/img_bg.png) center no-repeat;
  background-size: cover;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  text-align: center;
  color: #fff;
  padding-top: 45vh;
}

</style>



// WEBPACK FOOTER //
// Welcome.vue?949308e6